import { render, staticRenderFns } from "./ListMerchantVasses.vue?vue&type=template&id=1a64fb5d&"
import script from "./ListMerchantVasses.vue?vue&type=script&lang=ts&"
export * from "./ListMerchantVasses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports